import { render, staticRenderFns } from "./list-resource-actions.vue?vue&type=template&id=5b87e41c&scoped=true"
import script from "./list-resource-actions.vue?vue&type=script&lang=js"
export * from "./list-resource-actions.vue?vue&type=script&lang=js"
import style0 from "./list-resource-actions.vue?vue&type=style&index=0&id=5b87e41c&prod&lang=scss&scoped=true"
import style1 from "./list-resource-actions.vue?vue&type=style&index=1&id=5b87e41c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87e41c",
  null
  
)

export default component.exports